<template>
  <highliter
    v-model="section.name"
    section-type="element"
    class="highlight-element"
    :dublicate-deep="parentUID"
    :dublicate="section"
    :hide-right="true"
    @delete="$emit('delete')"
    @dublicate="$emit('dublicate')"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @add-subject="$emit('add-subject')"
    @click.stop.native="() => null"
  >
    <b-form-group
      class="estage-form-element-group mb-0"
      :class="`--${sid}--form-field --${sid}--form-field-card-exp-year`"
    >
      <v-select
        v-model="control.value"
        :options="expYearsOptions(2050)"
        required
        class="input"
        :class="`--${sid}--form-field-input`"
      />
    </b-form-group>
  </highliter>
</template>

<script>
import BorderMixin from '@/components/mixins/BorderMixin'
import SectionMixin from '@/components/mixins/SectionMixin'
import Highliter from '@/components/builder/utils/Highliter.vue'
export default {
  name: 'ElFieldCardExpYear',
  mixins: [BorderMixin, SectionMixin],
  components: {Highliter},
  computed: {
    control () {
      return this.section.options.content.control
    }
  },
  methods: {
    focus () {
      this.$el.querySelector('legend').classList.add('active')
    },
    blur () {
      this.$el.querySelector('legend').classList.remove('active')
    },
    expYearsOptions (endYear) {
      let startYear = new Date().getFullYear()
      const endDate = endYear || new Date().getFullYear()
      let years = []
      while (startYear <= endDate) {
        years.push(startYear)
        startYear++
      }
      return years
    }
  }
}
</script>